import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  meta: {
    title: '保证金缴纳审核通过详情',
    auth: true,
    authorityValue: "store-store-bond-info"
  },
  name: 'bondSuccess',
  data: function data() {
    return {
      dataObj: {}
    };
  },
  methods: {
    dataBind: function dataBind(item) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$api.depositDetails(item);

              case 2:
                data = _context.sent;
                _this.dataObj = data;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  },
  created: function created() {
    var query = this.$route.query;
    this.dataBind(query);
  }
};